<template>
<div id="representantes" >
    <div>
        <v-breadcrumbs :items="breadcrumbs" >
            <v-icon slot="divider" >forward</v-icon>
        </v-breadcrumbs>
    </div>
    <v-container fluid fill-height>
        <v-layout align-center justify-center>
            <v-flex xs12>
                <base-material-card color="primary" icon="library_books" title="Representantes Legales" class="elevation-1 px-5 py-3" >
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-speed-dial direction="left" open-on-hover>
                            <template v-slot:activator>
                                <v-btn x-small fab dark color="primary" >
                                    <v-icon>reorder</v-icon>
                                </v-btn>
                            </template>
                            <exportar-excel :data="datafiltered" :exportFields="representantes.camposexcel" name="Representantes.xlsx" >
                                <v-btn fab x-small dark color="success" title="Exportar" v-tippy>
                                    <v-icon dark>get_app</v-icon>
                                </v-btn>
                            </exportar-excel>
                            <upload-excel-component :on-success="handleSuccess" :before-upload="beforeUpload" />
                            <exportar-excel :data="representantes.camposLayout" :exportFields="representantes.encabezadoLayout" name="Layout Representantes Legales.xlsx" >
                                <v-btn fab dark x-small color="purple darken-2" title="Descargar Layout" v-tippy>
                                    <v-icon dark>receipt</v-icon>
                                </v-btn>
                            </exportar-excel>
                        </v-speed-dial>

                        <v-btn fab dark x-small color="secondary" slot="activator" @click.native="openModal(1)" title="Agregar Registro" v-tippy>
                            <v-icon dark>add</v-icon>
                        </v-btn>

                        <v-dialog v-model="modal" max-width="60%" style=" z-index: 400 !important;" >
                            <v-card>
                                <v-card-title>
                                    <v-card class="primary white--text titulomodal" >
                                        <v-icon class="white--text" @click.native="modal = false">cancel</v-icon>&nbsp;
                                        <span class="subheading" >
                                            <strong>{{ update ? "Actualizar" : "Nuevo" }} Representante
                                                Legal</strong>
                                        </span>
                                    </v-card>                                    
                                </v-card-title>
                                <v-form ref="form" lazy-validation>
                                    <v-card-text>
                                        <v-container grid-list-md text-xs-center @keyup.enter="guardar()" >
                                            <v-layout row wrap>
                                                <v-flex s12 m4 l4>
                                                    <v-text-field name="nombre" label="Nombre" type="text" v-model="model.nombre" :rules="[rules.required]" maxlength="100" ></v-text-field>
                                                </v-flex>
                                                <v-flex s12 m4 l4>
                                                    <v-text-field name="apellido_paterno" label="Apellido Paterno" type="text" v-model="model.apellido_paterno" :rules="[rules.required]" maxlength="100" ></v-text-field>
                                                </v-flex>
                                                <v-flex s12 m4 l4>
                                                    <v-text-field name="apellido_materno" label="Apellido Materno" type="text" v-model="model.apellido_materno" :rules="[rules.required]" maxlength="100" ></v-text-field>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row wrap>
                                                <v-flex s12 m3 l3>
                                                    <v-text-field name="rfc" label="RFC o TAX ID" type="text" @input="model.rfc = model.rfc.toUpperCase()" v-model="model.rfc" :rules="[rules.required, rules.rfclen]" maxlength="20" ></v-text-field>
                                                </v-flex>
                                                <v-flex s12 m6 l6>
                                                    <v-text-field name="escritura_publica" label="Escritura Pública" type="text" v-model="model.escritura_publica" :rules="[rules.required]" maxlength="20" ></v-text-field>
                                                </v-flex>
                                                <v-flex s12 m3 l3>
                                                    <v-text-field name="volumen" label="Volumen" type="text" v-model="model.volumen" :rules="[rules.required]" maxlength="20" ></v-text-field>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row wrap>
                                                <v-flex s12 m6 l6>
                                                    <v-text-field name="ciudad" label="Ciudad" type="text" v-model="model.ciudad" :rules="[rules.required]" maxlength="100" ></v-text-field>
                                                </v-flex>
                                                <v-flex s12 m6 l6>
                                                    <v-menu offset-x ref="menu1" :close-on-content-click="false" v-model="menu1" :nudge-right="40" transition="scale-transition" offset-y max-width="290px" min-width="290px" >
                                                        <template v-slot:activator="{ on }" >
                                                            <v-text-field v-model="model.fecha" label="Fecha" prepend-icon="event" @blur="model.fecha = parseDate(model.fecha)" v-mask="'####-##-##'" v-on="on" :rules="[rules.required]" ></v-text-field>
                                                        </template>
                                                        <v-date-picker v-model="model.fecha" no-title @input="menu1 = false" locale="es-mx" ></v-date-picker>
                                                    </v-menu>
                                                </v-flex>
                                            </v-layout>
                                            <v-flex s12 m4 l4>
                                                <v-text-field name="numero_notario" label="Número de Notario" type="text" v-model="model.numero_notario" :rules="[rules.required]" maxlength="10" ></v-text-field>
                                            </v-flex>
                                            <v-flex s12 m4 l4>
                                                <v-text-field name="nombre_notario" label="Nombre de Notario" type="text" v-model="model.nombre_notario" :rules="[rules.required]" maxlength="100" ></v-text-field>
                                            </v-flex>
                                            <v-flex s12 m4 l4>
                                                <v-text-field label="Estado de Aplicación" type="text" v-model="model.aplicacion_estado_nombre" maxlength="150" :rules="[rules.required]"></v-text-field>
                                            </v-flex>                                            
                                            <v-layout row wrap>
                                                <v-flex s12 m6 l6>
                                                    <v-text-field label="Estado" type="text" v-model="model.estado_nombre" maxlength="150" :rules="[rules.required]"></v-text-field>
                                                </v-flex>
                                                <v-flex s12 m6 l6>
                                                    <v-text-field name="metadato" label="Metadato" type="text" v-model="model.metadato" :rules="[rules.required]" maxlength="100" ></v-text-field>
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card-text>
                                </v-form>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn @click.native="modal = false" >
                                        <v-icon>cancel</v-icon> Cancelar
                                    </v-btn>
                                    <v-btn color="success" :loading="loading" @click.native="guardar()" >
                                        <v-icon>done</v-icon>
                                        {{ update ? "Actualizar" : "Guardar" }}
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                    </v-card-actions>

                    <v-card-text>
                        <div id="datagrid" >

                            <v-client-table ref="vuetable" :data="representantes.items" :columns="columns" :options="options" class="elevation-2 pa-2" >
                                <template slot="noResults" >
                                    <v-alert :value="true" icon="info" color="info" >No se encontró ningun registro</v-alert>
                                </template>

                                <template slot="actions" slot-scope="props" >
                                    <v-speed-dial :id="props.row.id" direction="left" open-on-hover>
                                        <template v-slot:activator>
                                            <v-btn :id="props.row.id" x-small fab dark color="primary" >
                                                <v-icon>reorder</v-icon>
                                            </v-btn>
                                        </template>
                                        <v-btn x-small fab dark color="red" @click.native="
                          agregar_pdf(props.row.id_representante_legal, props.row.nombre, 
                                        props.row.apellido_paterno, props.row.apellido_materno)
                        " title="PDF Tercero Autorizado" v-tippy>
                                            <v-icon>mdi-file-pdf-box</v-icon>
                                        </v-btn>
                                        <v-btn x-small fab dark color="green" @click.native="
                          agregar_firma(props.row.id_representante_legal)
                        " title="Actualizar Firmas" v-tippy>
                                            <v-icon>attach_file</v-icon>
                                        </v-btn>
                                        <v-btn x-small fab dark color="blue" @click.native="
                          getRegistro(props.row.id_representante_legal)
                        " title="Editar Registro" v-tippy>
                                            <v-icon>edit</v-icon>
                                        </v-btn>
                                        <v-btn x-small fab dark color="pink" @click.native="
                          deleteRegistro(props.row.id_representante_legal)
                        " title="Eliminar Registro" v-tippy>
                                            <v-icon>delete</v-icon>
                                        </v-btn>
                                    </v-speed-dial>
                                </template>
                            </v-client-table>
                        </div>
                    </v-card-text>
                </base-material-card>
            </v-flex>
        </v-layout>
    </v-container>
    <v-dialog v-model="modalPdf" max-width="40%" style=" z-index: 400 !important;" >
        <v-card>
            <v-card-title>
                <v-card class="primary white--text titulomodal" >
                    <v-icon class="white--text" @click.native="modalPdf = false">cancel</v-icon>&nbsp;
                    <span class="subheading" >
                        <strong>PDF Tercero Autorizado: {{nombre_representante_seleccionado}}</strong>
                    </span>
                </v-card>                                    
            </v-card-title>
            <v-form ref="formPdf" lazy-validation>
                <v-card-text>
                    <v-container grid-list-md text-xs-center>
                        <br>
                        <v-row row wrap>
                            <v-text-field :hint="existe_pdf==1?'Al cargar un nuevo archivo se reemplazará el existente':'Aún no se ha cargado un archivo'" persistent-hint 
                                label="Seleccione archivo PDF" @click='pickFile' v-model='name_file' :readonly="true" prepend-icon='attach_file'></v-text-field>
                            <input type="file" style="display: none" ref="file_input" accept=".pdf" @change="onFilePicked" >
                        </v-row>    
                        <br>                            
                        <v-row align="center" justify="center" v-if="existe_pdf==1">
                            <v-btn color="green" @click.native="downloadFile(key_pdf,'')" >
                                <v-icon>get_app</v-icon> Descargar PDF
                            </v-btn>                                                                
                        </v-row>
                    </v-container>
                </v-card-text>
            </v-form>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click.native="modalPdf = false" >
                    <v-icon>cancel</v-icon> Cancelar
                </v-btn>                                    
            </v-card-actions>
        </v-card>
    </v-dialog>
</div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import GridLoader from "vue-spinner/src/GridLoader.vue";
export default {
    components: {
        loader: GridLoader
    },

    data: () => ({
        fab: false,
        menu1: false,
        name: "datagrid",
        modalPdf: false,
        file: "",        
        name_file: "",
        size_file: 0,
        type_file: 'application/pdf',
        id_representante_seleccionado: "",
        nombre_representante_seleccionado:"",
        existe_pdf:0,
        key_pdf: "",

        importData: [],
        columns: [
            "nombre",
            "apellido_paterno",
            "apellido_materno",
            "rfc",
            "aplicacion_estado_nombre",
            "estado_nombre",
            "metadato",
            "actions"
        ],
        show_loading: true,
        options: {
            filterable: [
                "nombre",
                "apellido_paterno",
                "apellido_materno",
                "rfc",
                "aplicacion_estado_nombre",
                "estado_nombre",
                "metadato"
            ],
            sortable: [
                "nombre",
                "apellido_paterno",
                "apellido_materno",
                "rfc",
                "aplicacion_estado_nombre",
                "estado_nombre",
                "metadato"
            ],

            headings: {
                nombre: "Nombre",
                apellido_paterno: "Apellido Paterno",
                apellido_materno: "Apellido Materno",
                rfc: "RFC o TAX ID",
                aplicacion_estado_nombre: "Estado de Aplicación",
                estado_nombre: "Estado",
                metadato: "Metadato",
                actions: "Operaciones"
            }             
        },
        URL: "",
        show_loading: true,
        breadcrumbs: [{
                text: "Inicio",
                disabled: false,
                to: "/home"
            },
            {
                text: "Catálogos",
                disabled: true,
                to: ""
            },
            {
                text: "Representantes Legales",
                disabled: true,
                to: ""
            }
        ],
        loading: false,
        title: "",
        modal: false,
        update: false,
        pagination: {
            sortBy: "nombre"
        },
        search: "",
        model: {
            id_representante_legal: 0,
            nombre: "",
            apellido_paterno: "",
            apellido_materno: "",
            rfc: "",
            escritura_publica: "",
            volumen: "",
            ciudad: "",
            fecha: "",
            numero_notario: "",
            nombre_notario: "",
            aplicacion_estado: "",
            estado: "",
            aplicacion_estado_nombre: "",
            estado_nombre: "",
            cliente: 0,
            metadato: "N/A"
        },
        rules: {
            required: v => !!v || "Este campo es requerido",
            rfclen: v =>
                (v && v.length >= 9) || "RFC debe tener al menos 9 caractéres"
        },
        representantes: {
            selected: [],
            camposexcel: {
                Nombre: "nombre",
                "Apellido Paterno": "apellido_paterno",
                "Apellido Materno": "apellido_materno",
                RFC: "rfc",
                "Escritura Pública": "escritura_publica",
                Volumen: "volumen",
                Ciudad: "ciudad",
                Fecha: "fecha",
                "Número Notario": "numero_notario",
                "Nombre Notario": "nombre_notario",
                "Estado de Aplicación": "aplicacion_estado_nombre",
                Estado: "estado_nombre",
                Metadato: "metadato"
            },
            items: [0],
            //En el encabezado deben ser iguales los pares, respetando el nombre del campo definido en el modelo de la API
            encabezadoLayout: {
                nombre: "nombre",
                apellido_paterno: "apellido_paterno",
                apellido_materno: "apellido_materno",
                rfc: "rfc",
                escritura_publica: "escritura_publica",
                volumen: "volumen",
                ciudad: "ciudad",
                fecha: "fecha",
                numero_notario: "numero_notario",
                nombre_notario: "nombre_notario",
                aplicacion_estado: "aplicacion_estado",
                estado: "estado",
                metadato: "metadato"
            },
            //van vacíos para solo descargar layout con encabezados
            camposLayout: [{
                nombre: "[Nombre del Representante]",
                apellido_paterno: "",
                apellido_materno: "",
                rfc: "[RFC del Representante]",
                escritura_publica: "",
                volumen: "",
                ciudad: "",
                fecha: "[YYYY-mm-dd]",
                numero_notario: "",
                nombre_notario: "",
                aplicacion_estado: "[Nombre del Estado de Aplicación]",
                estado: "[Nombre del Estado]",
                metadato: ""
            }]
        },
        camposObligatorios: [
            "nombre",
            "apellido_paterno",
            "apellido_materno",
            "rfc",
            "escritura_publica",
            "volumen",
            "ciudad",
            "fecha",
            "numero_notario",
            "nombre_notario",
            "aplicacion_estado",
            "estado",
            "metadato"
        ],
        estados: [],
        paises: [],
    }),
    computed: {
        datafiltered() {
            if (this.$refs.vuetable != null) {
                return this.$refs.vuetable.allFilteredData;
            } else {
                return this.representantes.items;
            }

        },
    },
    methods: {
        parseDate(date) {
            //Formato  YYYY-MM-DD
            if (!date) return null;
            return moment(String(date)).format("YYYY-MM-DD");
        },
        openModal: function (type) {
            if (type === 1) {
                this.limpiarModel();
                this.title = "Nuevo Representante Legal";
                this.update = false;
            } else {
                this.title = "Actualizar Representante Legal";
                this.update = true;
            }
            this.modal = true;
        },

        limpiarModel: function () {
            for (var k in this.model) {
                this.model[k] = "";
            }
            this.model.cliente = this.$local_storage.get("id_cliente");
        },

        guardar() {
            const datos = {
                id_representante_legal: this.model.id_representante_legal,
                nombre: this.model.nombre,
                apellido_paterno: this.model.apellido_paterno,
                apellido_materno: this.model.apellido_materno,
                rfc: this.model.rfc,
                escritura_publica: this.model.escritura_publica,
                volumen: this.model.volumen,
                ciudad: this.model.ciudad,
                fecha: this.model.fecha,
                numero_notario: this.model.numero_notario,
                nombre_notario: this.model.nombre_notario,
                aplicacion_estado_nombre: this.model.aplicacion_estado_nombre,
                estado_nombre: this.model.estado_nombre,
                cliente: this.$local_storage.get("id_cliente"),
                metadato: this.model.metadato
            };

            if (!this.$refs.form.validate()) {
                //Alguna operación o mensaje
            } else {
                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                var metodo = "post";
                var urlCliente = this.URL;
                if (this.update == true) {
                    metodo = "put";
                    urlCliente += this.model.id_representante_legal + "/";
                }
                axios({
                        method: metodo,
                        url: urlCliente,
                        data: datos
                    })
                    .then(res => {
                        this.$swal({
                            type: "success",
                            title: "¡Operación Exitosa!",
                            text: "Los datos se guardaron correctamente",
                            footer: ""
                        });
                        this.cargar();
                        this.$root.$dialogLoader.hide();
                        this.modal = false;
                    })
                    .catch(error => {
                        this.$swal({
                            position: "center",
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un error al guardar los datos"
                            //showConfirmButton: false,
                        });
                        console.log(error);
                        this.cargar();
                        this.$root.$dialogLoader.hide();
                        this.modal = false;
                    });
            }
        },

        cargar: function () {
            var datos = {
                cliente: this.$local_storage.get("id_cliente")
            };
            axios
                .post(this.URL + "get_representantes/", datos)
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        this.representantes.items = res.data;
                        this.$root.$dialogLoader.hide();
                    }
                })
                .catch(err => {

                    console.log(err);
                    this.$root.$dialogLoader.hide();
                });
        },

        getRegistro: function (id_registro) {
            axios
                .get(this.URL + id_registro + "/")
                .then(response => {
                    this.model = response.data;
                    this.openModal(2); //ACTUALIZAR
                })
                .catch(error => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener el registro",
                        footer: ""
                    });
                });
        }, //getRegistro
        agregar_firma: function(id) {
          if(id > 0) {
            this.$local_storage.set("id_representante_legal", id);
            this.$router.push("/clientes/firmas");
          } else {
            this.$swal({
                type: "warning",
                title: "Error",
                text: "No se encontro tomo un valor correcto",
                footer: ""
            });
          }
        },
        reset() {
            const input = this.$refs.file_input;
            input.type = 'text';
            input.type = 'file';
            this.name_file = '';
        },
        pickFile() {
            this.$refs.file_input.click()
        },
        onFilePicked(e) {
            try {
                const files = e.target.files;
                
                if (files[0] !== undefined) {

                    this.name_file = files[0].name;
                    this.size_file = files[0].size;
                    this.type_file = files[0].type;
                                        
                    if (this.size_file > 1000 * 1000 * 3) {
                        this.$swal({
                            type: "warning",
                            title: "¡Operación no Permitida!",
                            text: "El archivo no debe ser mayor a 3MB.",
                        });
                        this.reset();
                        return false;
                    }
                    
                    this.uploadFile(files[0]);
                   
                }
            } catch (error) {
                console.log(error);
                this.$swal({
                    type: "error",
                    title: "¡Operación no Permitida!",
                    text: "Ocurrió un error al leer el archivo. Favor de verificar que el archivo no esté dañado.",
                    footer: ""
                });
                this.$root.$dialogLoader.hide();
                this.reset();
            }

        },

        uploadFile: function (file) {            
            
            var thisObj = this;
            var rfc= this.$local_storage.get("rfc");            
            var keyFile = rfc+"/pdf_representantes/" + thisObj.id_representante_seleccionado+".pdf" ;
            
            var datos = {
                key: keyFile,
                bucket: "production.econnect.ds",
                type: thisObj.type_file
            }
            
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            axios.post(thisObj.$hostname + 's3/upload_url/', datos)
                .then((res) => {
                    if (typeof res.data !== 'undefined') {                        
                        var urlput = res.data.mensaje;
                        //console.log(urlput);
                        axios.put(urlput, file, {headers:{'Content-Type': thisObj.type_file}})
                        .then((res) => {
                            this.$swal({
                                type: "success",
                                title: "Operación Exitosa",
                                text: "El archivo se guardó correctamente.",                                
                                footer: ""
                            });
                            this.modalPdf = false;
                            thisObj.$root.$dialogLoader.hide();
                            thisObj.reset();
                        })                            
                        .catch((error)=>{
                            thisObj.$root.$dialogLoader.hide();
                            thisObj.$swal({
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: "Ocurrió un erro al cargar el archivo. Favor de intentar nuevamente.",
                                footer: '',
                            });
                            thisObj.reset();
                            console.log(error);
                        });
                        
                    } else {
                        thisObj.$root.$dialogLoader.hide();
                        thisObj.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un erro al cargar el archivo. Favor de intentar nuevamente.",
                            footer: '',
                        });
                        thisObj.reset();
                    }
                })
                .catch((error) => {
                    var mensaje = "Ocurrió un error al cargar el archivo. Favor de intentar nuevamente.";
                    if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
                        mensaje = error.response.data.mensaje;
                    thisObj.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: mensaje,
                        footer: '',
                    });
                    console.log(error);
                    thisObj.$root.$dialogLoader.hide();
                    thisObj.reset();
                });
                
        },
        agregar_pdf: function(id_representante_legal, nombre, apaterno, amaterno){
            this.id_representante_seleccionado = id_representante_legal;
            this.nombre_representante_seleccionado = nombre+" "+apaterno+" "+amaterno;            
            var rfc= this.$local_storage.get("rfc");            
            this.key_pdf = rfc+"/pdf_representantes/" + this.id_representante_seleccionado+".pdf" ;             
            this.downloadFile(this.key_pdf, "mostrar");            
        },
        downloadFile: function (key, opcion="") {            
            
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var datos = {
                id: key,
                bucket: "production.econnect.ds"
            }
            axios.post(this.$hostname + 's3/download_url/', datos)
                .then((res) => {
                    if (typeof res.data !== 'undefined') {
                        if(opcion==""){
                            var a = document.createElement("a");
                            document.body.appendChild(a);
                            a.style = "display: none";
                            a.href = res.data.mensaje;
                            a.target = "_blank";
                            a.click();
                            a.parentNode.removeChild(a);
                        } else {
                            this.existe_pdf = 1;
                            this.modalPdf = true;
                        }
                        

                    } else {
                        if(opcion==""){
                            this.$swal({
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: "No se encontró el archivo a descargar. Intente nuevamente por favor.",
                                footer: '',
                            });
                        } else {
                            this.existe_pdf = 0;
                            this.modalPdf = true;
                        }                        
                    }
                })
                .catch((error) => {
                    if(opcion==""){
                        var mensaje = "Ocurrió un error al descargar el archivo";
                        if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
                            mensaje = error.response.data.mensaje;
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: mensaje,
                            footer: '',
                        });
                        console.log(error);
                    } else {
                        this.existe_pdf = 0;
                        this.modalPdf = true;
                    }
                    
                }).then(() => {
                    this.$root.$dialogLoader.hide();
                });
        },

        cargarPaises: function () {
            axios
                .get(this.$hostname + "paises/")
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        this.paises = res.data;
                        var search = res.data.filter(function (e) {
                            return e.clave_m3.toString().trim().toLowerCase() == 'mex';
                        });                        
                    } else {
                        this.$swal({
                            type: "warning",
                            title: "Aviso",
                            text: "No se han ingresado datos al catálogo de países",
                            footer: ""
                        });
                    }
                })
                .catch(err => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener el catálogo de países.",
                        footer: ""
                    });
                    console.log(err);
                });
        },

        deleteRegistro: function (id_registro) {
            this.$swal({
                type: "info",
                title: "Cuidado",
                text: "¿Está seguro de eliminar el registro?",
                footer: "",
                showCancelButton: true,
                cancelButtonColor: "#d33",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Aceptar",
                cancelButtonText: "Cancelar"
            }).then(result => {
                if (result.value)
                    axios
                    .delete(this.URL + id_registro + "/")
                    .then(response => {
                        this.cargar();
                        this.$swal({
                            type: "success",
                            title: "Operación Exitosa",
                            text: "El registro se eliminó correctamente.",
                            //position: 'bottom-end',
                            //timer: 3000,
                            //showConfirmButton: false,
                            footer: ""
                        });
                    })
                    .catch(error => {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un error al eliminar el registro",
                            footer: ""
                        });
                    });
            });
        },
        beforeUpload(file) {
            const isLt2M = file.size / 1024 / 1024 < 2;

            if (isLt2M) {
                return true;
            }
            this.$swal({
                type: "warning",
                title: "¡Operación no Permitida!",
                text: "El archivo no debe ser mayor a 2MB.",
                footer: ""
            });
            return false;
        },
        parseDateExcel(excelDate) {
            try {
                if (!excelDate) return false;
                var fecha = '';
                if (excelDate.toString().indexOf('/') != -1 || excelDate.toString().indexOf('-') != -1)
                    fecha = moment(String(excelDate)).format("YYYY-MM-DD");
                else
                    fecha = moment((excelDate - (25567 + 1)) * 86400 * 1000).format("YYYY-MM-DD");
                if (fecha == 'Invalid date') return false;
                return fecha;
            } catch (error) {
                return false;
            }
        },
        verificaObligatorios: function (results) {
            var errores = '';
            var keys = [];
            for (var k in results) {
                keys.push(k);
            }
            this.camposObligatorios.forEach(function (campo) {
                if (keys.indexOf(campo) == -1)
                    errores += '<br/>' + "- El campo '" + campo + "' es obligatorio.";
            });

            return errores == '' ? true : errores;
        },
        verificaComboPaises: async function (clave_pais) {
            var erroresText = '';
            let verificaP = await this.verificaPais(clave_pais, '');
            if (verificaP == 0) {
                erroresText += "- La clave país \"" + clave_pais + "\" no existe en el sistema.<br>";
            }
            return erroresText;
        },
        verificaPais: function (clave_pais, opcion) {
            var thisObject = this;
            return new Promise(function (resolve, reject) {
                if (clave_pais == undefined)
                    resolve(0);

                var search = thisObject.paises.filter(function (e) {
                    return e.clave_m3.toString().trim().toLowerCase() == clave_pais.toString().trim().toLowerCase();
                });
                if (opcion == 'id')
                    resolve(search.length > 0 ? search[0].id_pais : '');
                else
                    resolve(search.length);
            });

        },
        validaCargaLayout: async function (results) {
            var thisObject = this;
            //return new Promise(function(resolve, reject){
            var errores = 0;
            var erroresText = '';
            var errorTmp = '';
            try {
                if (results.length == 0) {
                    errores++;
                    erroresText += "No hay datos en el layout. Verifique que exista información a partir del 3er renglón.";
                } else {
                    for (var k in results) {
                        results[k]["user_updated"] = this.$local_storage.get("email");
                        results[k]["cliente"] = this.$local_storage.get("id_cliente");

                        var fechaOrig = results[k]["fecha"];
                        results[k]["fecha"] = this.parseDateExcel(results[k]["fecha"]);

                        var obligatorios = this.verificaObligatorios(results[k]);
                        if (obligatorios !== true) {
                            errores++;
                            if (erroresText.indexOf(obligatorios) == -1)
                                erroresText += obligatorios;
                        } else if (results[k]["fecha"] == false) {
                            errores++;
                            errorTmp = '<br/>' + "- La fecha '" + fechaOrig + "' no es una fecha válida.";
                            if (erroresText.indexOf(errorTmp) == -1)
                                erroresText += errorTmp;
                        } else {
                            results[k]["pais"] = 'MEX';
                            let verificaEstado = await thisObject.verificaComboPaises(results[k]["pais"]);
                            if (verificaEstado.toString().trim().length > 0) {
                                errores++;
                                if (erroresText.indexOf(verificaEstado) == -1)
                                    erroresText += verificaEstado;
                            }
                            let verificaEstadoAplicacion = await thisObject.verificaComboPaises(results[k]["pais"]);
                            if (verificaEstadoAplicacion.toString().trim().length > 0) {
                                errores++;
                                if (erroresText.indexOf(verificaEstadoAplicacion) == -1)
                                    erroresText += verificaEstadoAplicacion;
                            }

                        }
                        //console.log("Key is " + k + ", value is" + results[k]);
                    }

                }

                return ({
                    "errores": errores,
                    "erroresText": erroresText
                });

            } catch (error) {
                console.log(error);
                thisObject.$swal({
                    type: "warning",
                    title: "¡Operación no Permitida!",
                    text: "Error al cargar el archivo. Verifique que no existan celdas vacías.",
                    footer: error.message,
                });
            }
            //}); //promise

        },
        handleSuccess: async function ({
            results,
            header
        }) {
            var errores = 0;
            var erroresText = '';
            this.importData = [];
            try {
                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                let validaciones = await this.validaCargaLayout(results);
                if (validaciones.errores > 0) {
                    this.$swal({
                        type: "warning",
                        title: "¡Operación no Permitida!",
                        text: "Existen errores al cargar el archivo. Corrija y vuelva a intentarlo.",
                        footer: validaciones.erroresText,
                    });
                    this.$root.$dialogLoader.hide();
                } else {
                    for (var k in results) {

                        var id_pais = results[k]["pais"] != undefined ? await this.verificaPais(results[k]["pais"], 'id') : '';
                        
                        this.importData.push({
                            nombre: results[k]["nombre"],
                            apellido_paterno: results[k]["apellido_paterno"],
                            apellido_materno: results[k]["apellido_materno"],
                            rfc: results[k]["rfc"],
                            escritura_publica: results[k]["escritura_publica"],
                            volumen: results[k]["volumen"],
                            ciudad: results[k]["ciudad"],
                            fecha: results[k]["fecha"],
                            numero_notario: results[k]["numero_notario"],
                            nombre_notario: results[k]["nombre_notario"],
                            aplicacion_estado_nombre: results[k]["aplicacion_estado"],
                            estado_nombre: results[k]["estado"],
                            metadato: results[k]["metadato"],
                            cliente: results[k]["cliente"],
                            user_updated: results[k]["user_updated"],
                        });

                    }

                    axios
                        .post(this.URL + "importar_representantes/", this.importData)
                        .then(() => {
                            this.$swal({
                                type: "success",
                                title: "¡Operación Exitosa!",
                                text: "Los datos se guardaron correctamente",
                                footer: ""
                            });
                        })
                        .catch(err => {
                            var errores = "";
                            if (typeof err.response.data != "undefined") {
                                if (typeof err.response.data == "string") {
                                    let pos = errores.indexOf(err.response.data);
                                    if (pos < 0) {
                                        errores += err.response.data;
                                        errores += "<br>";
                                    }
                                } else
                                    for (var i = 0; i < err.response.data.length; i++) {
                                        Object.keys(err.response.data[i]).forEach(function (key) {
                                            var errors = err.response.data[i][key];
                                            if (key != 'contactos' && key != 'domicilios') { //Este trae 2 niveles, por eso el campo queda en la key2
                                                Object.keys(errors).forEach(function (key2) {
                                                    let pos = errores.indexOf(key + ": " + errors[key2]);
                                                    if (pos < 0) {
                                                        errores += key + ": " + errors[key2];
                                                        errores += "<br>";
                                                    }
                                                });
                                            } else { //contactos y domicilios, traen 3 niveles, por eso el campo queda en la key3
                                                Object.keys(errors).forEach(function (key2) {
                                                    Object.keys(errors[key2]).forEach(function (key3) {
                                                        let pos = errores.indexOf(key3 + ": " + errors[key2][key3]);
                                                        if (pos < 0) {
                                                            errores += key3 + ": " + errors[key2][key3];
                                                            errores += "<br>";
                                                        }

                                                    });
                                                });
                                            }

                                        });
                                    }
                            }
                            this.$swal({
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: "Existen errores al cargar el archivo. Corrija y vuelva a intentarlo. \nVerifique que los encabezados correspondan con el layout.",
                                footer: errores
                            });
                        })
                        .then(() => {
                            this.cargar();
                            this.$root.$dialogLoader.hide();
                        });
                }

            } catch (error) {
                this.$swal({
                    type: "warning",
                    title: "¡Operación no Permitida!",
                    text: "Error al cargar el archivo. Verifique que no existan celdas vacías.",
                    footer: error.message,
                });
                this.$root.$dialogLoader.hide();
            }
        }
    }, //methods

    created: function () {
        this.$local_storage.set("id_representante_legal", null);
        this.URL = this.$hostname + "catalogos/representantes/";        
        this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
        this.cargar();
        this.cargarPaises();

    }
};
</script>
